import { ConfiguracionDelimitador, ConfiguracionDelimitadorForm, ConfiguracionDelimitadorUpsert } from '@models/.';

export function transformToData(delimiterSetting: ConfiguracionDelimitador | null): ConfiguracionDelimitador | null {
  if (!delimiterSetting) return null;
  
  return {
    ...delimiterSetting,
  };
}

export function transformToForm(delimiterSetting: ConfiguracionDelimitador): ConfiguracionDelimitadorForm {
  const {
    id,
    leadingCharacter,
    trailingCharacter,
    accountId,
  } = delimiterSetting;
  
  return {
    id,
    leadingCharacter,
    trailingCharacter,
    accountId,
  };
}

export function transformToUpsert(delimiterSettingForm: ConfiguracionDelimitadorForm): ConfiguracionDelimitadorUpsert | undefined {
  if (!delimiterSettingForm) return;
  
  const {
    leadingCharacter,
    trailingCharacter,
  } = delimiterSettingForm;
  
  return {
    leadingCharacter,
    trailingCharacter,
  };
}